import { render, staticRenderFns } from "./RadioContainer.vue?vue&type=template&id=5224d5a3&scoped=true&"
import script from "./RadioContainer.vue?vue&type=script&lang=ts&"
export * from "./RadioContainer.vue?vue&type=script&lang=ts&"
import style0 from "./RadioContainer.vue?vue&type=style&index=0&id=5224d5a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224d5a3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default,AtomsTooltip: require('/var/www/packages/theme/components/atoms/Tooltip.vue').default,AtomsRadioButton: require('/var/www/packages/theme/components/atoms/RadioComponent/RadioButton.vue').default})
